import {
  Paper,
  Box,
  Stack,
  Typography,
  Chip,
  IconButton,
  Collapse,
  Divider,
  alpha,
  useTheme,
} from "@mui/material";
import {
  ExpandMore,
  CalendarMonth,
  WorkHistory,
  Coffee,
} from "@mui/icons-material";
import BreakDetailsTable from "./BreakDetailsTable";

const BreakLogItem = ({
  breakLog,
  index,
  isExpanded,
  onExpandClick,
  detailsPage,
  detailsPerPage,
  onDetailsPageChange,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        borderRadius: 2,
        borderColor: isExpanded ? "primary.main" : "divider",
        transition: "all 0.2s ease-in-out",
        overflow: "hidden",
        bgcolor: "white",
      }}
    >
      <Box
        onClick={() => onExpandClick(index)}
        sx={{
          p: 2,
          cursor: "pointer",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          justifyContent: "space-between",
          gap: 2,
          "&:hover": {
            bgcolor: alpha(theme.palette.primary.main, 0.04),
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              p: 1,
              borderRadius: "50%",
              display: "flex",
            }}
          >
            <CalendarMonth color="primary" fontSize="small" />
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight="600">
              {breakLog.date}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {`Total Session${breakLog.total_break !== 1 ? "s" : ""}: ${
                breakLog.total_break
              }`}
            </Typography>
          </Box>
        </Stack>

        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
        >
          <Chip
            icon={<Coffee fontSize="small" color="warning" />}
            label={`Break: ${breakLog.break}`}
            variant="outlined"
            sx={{
              fontWeight: 500,
              color: theme.palette.warning.dark,
              bgcolor: alpha(theme.palette.warning.main, 0.05),
              borderColor: alpha(theme.palette.warning.main, 0.3),
            }}
          />
          <Chip
            icon={<WorkHistory fontSize="small" />}
            label={`Work: ${breakLog.work}`}
            color="success"
            variant="outlined"
            sx={{
              fontWeight: 500,
              bgcolor: alpha(theme.palette.success.main, 0.05),
            }}
          />
          <IconButton
            size="small"
            sx={{
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "0.2s",
              color: "text.secondary",
            }}
          >
            <ExpandMore />
          </IconButton>
        </Stack>
      </Box>

      <Collapse in={isExpanded} unmountOnExit>
        <Divider />
        <Box
          sx={{
            p: 2,
            bgcolor: alpha(theme.palette.grey[500], 0.02),
          }}
        >
          <Typography
            variant="caption"
            fontWeight="700"
            color="text.secondary"
            display="block"
            mb={1.5}
            textTransform="uppercase"
            letterSpacing={0.5}
          >
            Break Details
          </Typography>

          <BreakDetailsTable
            breakDetails={breakLog.break_details || []}
            currentPage={detailsPage}
            itemsPerPage={detailsPerPage}
            onPageChange={(newPage) => onDetailsPageChange(index, newPage)}
          />
        </Box>
      </Collapse>
    </Paper>
  );
};

export default BreakLogItem;
